import { Pipe, PipeTransform } from '@angular/core';
import { AnnouncementDto } from '@careapp-group/ng-sdk-v2-new';
import { isBefore, parseISO } from 'date-fns';

/**
 * True if the given announcement is pinned, and the pin has not expired.
 */
@Pipe({
  name: 'isAnnouncementPinned',
  pure: true,
})
export class IsAnnouncementPinnedPipe implements PipeTransform {
  transform(announcement: AnnouncementDto): boolean {
    // Is the item pinned?
    if (!announcement || !announcement.pinnedUntil) {
      return false;
    }

    let date: Date;

    // Handle if a date has been passed in.
    if ((announcement.pinnedUntil as any) instanceof Date) {
      date = announcement.pinnedUntil as any as Date;
    } else {
      date = parseISO(announcement.pinnedUntil as any);
    }

    // Has that pin expired?
    return isBefore(Date.now(), date);
  }
}
